var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 22,
    width: 4,
    height: 20,
    rx: 2,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 4,
    height: 32,
    rx: 2,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 20,
    width: 4,
    height: 24,
    rx: 2,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 14,
    width: 4,
    height: 36,
    rx: 2,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 18,
    width: 4,
    height: 28,
    rx: 2,
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 24,
    width: 4,
    height: 16,
    rx: 2,
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 12,
    r: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 6 L52 8 M52 16 L52 18 M46 12 L48 12 M56 12 L58 12",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiset);
export default __webpack_public_path__ + "static/media/aiset.279fd957a4e4c4e0d6d2d2e4355c8b16.svg";
export { ForwardRef as ReactComponent };